module.exports = __webpack_public_path__ + "img/managertips_lg.daa9d461.png";